import MuiMultiSelect from './muiMultiSelect'
export default MuiMultiSelect
